import { shadowColor } from '../../../domain/theming';

export const buildShadowContentBoxShadow = (isDark: boolean) => {
    const color = shadowColor(isDark);

    return `0 1.6px 3.5px ${color}`;
};
